import home from './home'
import live from './live'
import short from './short'
import channel from './channel'
import Layout from './Root.vue'
export default [
    {
        path: '/lives',
        component: Layout,
        children: [
            ...home,
            ...live,
            ...short,
            ...channel,
        ]
    },
]